/* ==========================================================================
   Casemira C3 : la tête de collection, vague 4
   bandeau (.cmb) + tuiles de taille (.cmt) + bloc univers (.cmu)
   --------------------------------------------------------------------------
   Quatre gestes, pas un de plus :

     1. « En savoir plus » déplie le texte de collection, qui était déjà dans
        le document (replié, jamais chargé après coup : c'est du contenu
        référencé) ;
     2. la boucle vidéo du bandeau est demandée APRÈS `window.load`, et encore,
        seulement si la connexion et les préférences de mouvement le permettent ;
     3. une tuile de taille coche le palier correspondant dans le formulaire de
        facettes de la vague 1, décoche les autres, et laisse `facets.js` faire
        le reste ;
     4. la carte « Le fait main » du bloc univers joue sa boucle au survol, sur
        ordinateur seulement.

   Comme en vague 1 et 2, tous les écouteurs sont délégués au document et posés
   UNE fois : ils survivent aux re-rendus AJAX de `#FacetFiltersContainer` sans
   aucun rebranchement. Ce script ne mémorise aucun état : les tuiles, leurs
   compteurs et leur tuile active sont recalculés par Liquid à chaque rendu.
   ========================================================================== */

(function () {
  'use strict';

  var DESKTOP = '(min-width: 1000px)';
  /* La boucle du bandeau suit la charnière du `<picture>`, pas celle de la
     grille : entre 750 et 999 px la photo servie est déjà celle d'ordinateur, et
     servir la vidéo de téléphone (800 x 370) sur une bande de 5,28:1 la
     recadrait de moitié. Vague 7. */
  var BAND_DESKTOP = '(min-width: 750px)';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Économie de données, 2G, 3G : on ne descend pas 1,4 Mo de décor. */
  function stingyNetwork() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var t = c.effectiveType || '';
    return t === 'slow-2g' || t === '2g' || t === '3g';
  }

  function idle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      window.setTimeout(fn, 400);
    }
  }

  /* ── 1. Le texte de collection ─────────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-cmb-more]') : null;
    if (!button) return;

    event.preventDefault();
    var id = button.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;

    /* VAGUE 9, point 3 : il n'y a plus qu'UN déclencheur par panneau. Le second
       « Réduire », rendu sous le texte déplié en vague 8, est retiré : la
       commande ne change plus de place selon son état. La boucle qui reposait
       l'`aria-expanded` sur tous les déclencheurs d'un même panneau n'a donc
       plus d'objet - un seul bouton ne peut pas se contredire. */
    var open = button.getAttribute('aria-expanded') === 'true';
    panel.hidden = open;
    button.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* ── 2. La boucle du bandeau, variante C (vague 9, point 1) ─────────────────
     Elle ne vit plus PAR-DESSUS la photo : elle a sa carte, à droite du texte,
     et elle n'existe que sur ordinateur. Trois conséquences dans ce script :

       · la charnière est celle du `<picture>` (750 px) et non celle de la
         grille : c'est la largeur à laquelle la variante C paraît. En dessous,
         on ne demande RIEN - pas une requête, pas un octet ;
       · l'adresse n'est posée qu'après `window.load`, comme depuis la vague 4 :
         la vidéo ne dispute jamais la bande passante à l'image LCP ;
       · le fondu ne part qu'une fois la boucle réellement jouable (`canplay`),
         sinon on découvrirait un rectangle noir par-dessus le poster.

     Mouvement réduit ou connexion économe : on s'arrête avant tout, et le poster
     reste. C'est le résultat qu'on montre aussi quand la lecture est refusée par
     le navigateur - donc un résultat qui a été regardé, pas un repli par
     accident. */

  function startHeroVideo() {
    var video = document.querySelector('.cmb__vc[data-cmb-video]');
    if (!video || video.dataset.cmbStarted === '1') return;
    if (!window.matchMedia(BAND_DESKTOP).matches) return;
    if (reducedMotion() || stingyNetwork()) return;

    var src = video.dataset.cmbVideo;
    if (!src) return;

    video.dataset.cmbStarted = '1';
    video.addEventListener(
      'canplay',
      function () {
        video.classList.add('is-on');
      },
      { once: true }
    );
    video.src = src;
    video.load();
    var played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function () {
        /* Lecture refusée (onglet en arrière-plan, politique du navigateur) :
           le poster reste, et c'est un résultat acceptable. */
        video.classList.remove('is-on');
      });
    }
  }

  if (document.readyState === 'complete') {
    idle(startHeroVideo);
  } else {
    window.addEventListener(
      'load',
      function () {
        idle(startHeroVideo);
      },
      { once: true }
    );
  }

  /* Une fenêtre qui s'élargit fait paraître la carte : sans cette ligne, la
     boucle resterait éteinte jusqu'au prochain chargement. La garde
     `cmbStarted` fait que l'inverse - se rétrécir puis se rélargir - ne relance
     rien deux fois. */
  var bandQuery = window.matchMedia ? window.matchMedia(BAND_DESKTOP) : null;
  if (bandQuery && bandQuery.addEventListener) {
    bandQuery.addEventListener('change', function () {
      idle(startHeroVideo);
    });
  }

  /* ── 3. Les tuiles de taille ───────────────────────────────────────────── */

  function facetForm() {
    var bar = document.querySelector('casemira-filter-bar');
    return bar ? bar.querySelector('form[is="facet-form"]') : null;
  }

  /* Un palier est une valeur de la facette Balises. Shopify combine deux
     balises en ET : deux paliers cochés donneraient leur intersection, jamais
     leur union. Le palier est donc un choix UNIQUE, exactement comme dans le
     panneau Taille de la vague 1, dont cette fonction reprend la règle. */
  function applyTile(name, value, wasOn) {
    var form = facetForm();
    if (!form) return false;

    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var target = null;
    form.querySelectorAll(selector).forEach(function (input) {
      if (input.value === value) target = input;
    });
    if (!target) return false;

    form.querySelectorAll('input[data-cmc-palier]').forEach(function (input) {
      input.checked = false;
    });
    target.checked = !wasOn;

    /* Un seul point de sortie, celui de la vague 1 : on repasse la main à
       facets.js en simulant le `change` que le formulaire attend. */
    form.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* RETROFIT i18n (R3g, 05/09/2026) · le même geste, sans la facette Balises.
     Hors locale primaire, Shopify n'expose PAS `filter.p.tag` et ne l'applique pas
     davantage (mesuré : `?filter.p.tag=taille-groupe:Grand` rend 0 produit en /en
     contre 456 en /fr). La tuile porte alors la liste des COTES de son palier, et
     ce sont les cases de `filter.v.option.taille` qu'elle coche - les mêmes que
     « Cotes exactes », rendues dans toutes les langues.

     Le palier reste un choix UNIQUE : on part des cases à zéro et on ne coche que
     les siennes. Un second clic les décoche toutes. C'est la règle de la vague 1,
     transposée : ce que la tuile promet est exactement ce que la page rend. */
  function applyCotes(name, list, wasOn) {
    var form = facetForm();
    if (!form) return false;

    var inputs = form.querySelectorAll('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!inputs.length) return false;

    var wanted = wasOn ? [] : list.split('~');
    inputs.forEach(function (input) {
      input.checked = wanted.indexOf(input.value) !== -1;
    });

    form.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  document.addEventListener('click', function (event) {
    var tile = event.target.closest ? event.target.closest('[data-cmt-palier]') : null;
    if (!tile) return;

    event.preventDefault();
    var wasOn = tile.getAttribute('aria-pressed') === 'true';
    var applied = tile.dataset.cmtCotes
      ? applyCotes(tile.dataset.cmtName, tile.dataset.cmtCotes, wasOn)
      : applyTile(tile.dataset.cmtName, tile.dataset.cmtValue, wasOn);
    if (!applied) return;

    /* Retour visuel dans la même image, avant le recompte : la case cochée est
       invisible (elle vit dans le panneau Taille), c'est donc à la tuile de se
       peindre elle-même. Le rendu AJAX qui suit repose l'état depuis Liquid. */
    var rail = tile.parentNode;
    if (rail) {
      rail.querySelectorAll('[data-cmt-palier]').forEach(function (other) {
        other.classList.remove('is-on');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    tile.classList.toggle('is-on', !wasOn);
    tile.setAttribute('aria-pressed', wasOn ? 'false' : 'true');
  });

  /* ── 4. La carte « Le fait main » ──────────────────────────────────────── */

  function univers(event) {
    var card = event.target.closest ? event.target.closest('.cmu__card') : null;
    if (!card) return;
    var video = card.querySelector('[data-cmu-video]');
    if (!video) return;
    if (reducedMotion() || stingyNetwork()) return;
    if (!window.matchMedia(DESKTOP).matches) return;

    if (event.type === 'pointerenter' || event.type === 'focusin') {
      if (!video.src) video.src = video.dataset.cmuVideo;
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
      card.classList.add('is-playing');
    } else {
      card.classList.remove('is-playing');
      if (!video.paused) video.pause();
    }
  }

  ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach(function (type) {
    document.addEventListener(type, univers, true);
  });

  /* ── 5. La même carte, au TÉLÉPHONE (vague 7) ───────────────────────────────
     Sur ordinateur, la boucle part au survol : le geste existe, il est explicite,
     et rien ne se charge tant qu'il n'a pas lieu. Au téléphone il n'y a pas de
     survol, et la carte se réduisait donc à une pastille de lecture posée sur
     une photo fixe - un bouton qui promet une vidéo et qui, faute de survol, ne
     la donne jamais (point 17 du retour de Raph).

     La boucle part maintenant toute seule quand la carte ENTRE dans l'écran, et
     s'arrête quand elle en sort. Trois garde-fous, et ce sont ceux du bandeau :
       · muette, `playsinline`, `preload="none"` (le Liquid les pose déjà) : rien
         n'est demandé au réseau avant que l'observateur ne le décide ;
       · mouvement réduit ou connexion économe : on ne descend rien du tout, la
         photo reste, et c'est un résultat acceptable ;
       · une seule carte porte une vidéo dans tout le bloc (« Le fait main »),
         donc il n'y a jamais deux boucles à l'écran.

     Le seuil de 0,5 et non 0,01 : une carte à moitié visible est une carte qu'on
     regarde, une carte qui affleure est une carte qu'on traverse. Et `pause()`
     plutôt que vider la `src` : revenir sur la carte relance la boucle depuis la
     mémoire du navigateur, sans un octet de plus.

     L'observateur est (re)posé à chaque rendu AJAX : le bloc univers vit dans
     `#ProductsList`, que `facets.js` remplace en entier. Les nœuds observés
     n'existent plus après un filtre, l'observateur d'avant n'observe donc plus
     rien. */
  var universObserver = null;

  function watchUniversVideos() {
    if (typeof window.IntersectionObserver !== 'function') return;
    if (window.matchMedia(DESKTOP).matches) return;
    if (reducedMotion() || stingyNetwork()) return;

    if (universObserver) universObserver.disconnect();

    /* On part de la VIDÉO et on remonte à sa carte : c'est la carte qu'on
       observe (elle a une hauteur, la vidéo transparente n'en a pas toujours)
       et c'est elle qui porte la classe `is-playing`. */
    var cards = [];
    document.querySelectorAll('[data-cmu-video]').forEach(function (video) {
      var card = video.closest ? video.closest('.cmu__card') : null;
      if (card && cards.indexOf(card) === -1) cards.push(card);
    });
    if (!cards.length) return;

    universObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var video = card.querySelector('[data-cmu-video]');
          if (!video) return;

          if (entry.isIntersecting) {
            if (!video.src) video.src = video.dataset.cmuVideo;
            var played = video.play();
            if (played && typeof played.catch === 'function') {
              played.catch(function () {
                /* Lecture refusée : la photo reste, et la pastille avec elle. */
                card.classList.remove('is-playing');
              });
            }
            card.classList.add('is-playing');
          } else {
            card.classList.remove('is-playing');
            if (!video.paused) video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    cards.forEach(function (card) {
      universObserver.observe(card);
    });
  }

  if (document.readyState === 'complete') {
    idle(watchUniversVideos);
  } else {
    window.addEventListener(
      'load',
      function () {
        idle(watchUniversVideos);
      },
      { once: true }
    );
  }

  /* Le bloc univers est une cellule de `#ProductsList` : chaque filtre le
     recrée. On réarme sur l'événement que `facets.js` diffuse déjà. */
  document.addEventListener('collection:rerendered', function () {
    idle(watchUniversVideos);
  });

  /* ── 6. C7, points E3 puis I2 : les tuiles Couloir / Escalier ─────────────
     Le geste n'a pas changé depuis la vague 1, seul son habillage l'a fait :
     les deux segments de texte sont devenus deux TUILES PHOTO (point I2), et
     elles portent le même `data-cms-seg`. Rien ici n'a besoin de le savoir.

     Une tuile est une valeur de la facette `filter.p.m.custom.filtre_pieces`.
     Deux valeurs cochées donneraient leur INTERSECTION (Shopify combine deux
     valeurs d'une même facette de métachamp en ET), c'est-à-dire zéro tapis :
     le choix est donc exclusif par nécessité, pas par goût. Re-cliquer le
     segment actif le décoche et rend les 122 tapis, ce qui est l'état neutre
     de la collection : il n'y a pas de troisième segment « Tous » à afficher.

     Même point de sortie que les tuiles : on coche la case du formulaire de
     facettes et on laisse `facets.js` faire le rendu. Aucun `location.href`. */
  function applySegment(name, value, wasOn) {
    var form = facetForm();
    if (!form) return false;

    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var target = null;
    var champs = form.querySelectorAll(selector);
    champs.forEach(function (input) {
      if (input.value === value) target = input;
    });
    if (!target) return false;

    /* Toutes les valeurs de CETTE facette tombent, y compris celles qui n'ont
       pas de segment (« Extérieur » ici) : sans cela un état posé par le
       panneau Pièce survivrait au clic et le commutateur mentirait. */
    champs.forEach(function (input) {
      input.checked = false;
    });
    target.checked = !wasOn;

    form.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  document.addEventListener('click', function (event) {
    var seg = event.target.closest ? event.target.closest('[data-cms-seg]') : null;
    if (!seg) return;

    event.preventDefault();
    var wasOn = seg.getAttribute('aria-pressed') === 'true';
    if (!applySegment(seg.dataset.cmsName, seg.dataset.cmsValue, wasOn)) return;

    /* Retour visuel dans la même image : la case cochée vit dans un panneau
       fermé, c'est au segment de se peindre. Le rendu AJAX qui suit repose
       l'état depuis Liquid, il ne peut pas y avoir de désaccord durable. */
    var groupe = seg.parentNode;
    if (groupe) {
      groupe.querySelectorAll('[data-cms-seg]').forEach(function (other) {
        other.classList.remove('is-on');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    seg.classList.toggle('is-on', !wasOn);
    seg.setAttribute('aria-pressed', wasOn ? 'false' : 'true');
  });
})();
